import axios from 'axios';

export const axiosPublicInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    Accept: '*/*',
  },
});

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
  headers: {
    Authorization: `JWT ${JSON.parse(
      localStorage.getItem('access_token') as string,
    )}`
      ? `JWT ${JSON.parse(localStorage.getItem('access_token') as string)}`
      : '',
    'Content-Type': 'application/json',
    Accept: '*/*',
  },
});

axiosInstance.interceptors.response.use(
  // if we get the response we want, we directly return it
  (response) => {
    return response;
  },

  async function (error) {
    const originalRequest = error.config;
    // if we get a server error, we will reject the api call directly
    if (typeof error.response === 'undefined') {
      alert(
        'A server/network error occurred. ' +
          'Looks like CORS might be the problem. ' +
          'Sorry about this - we will get it fixed shortly.',
      );
      return Promise.reject(error);
    }

    // when a user is not authenticated, we will redirect him to the login page
    if (
      error.response.status === 401 &&
      originalRequest.url === process.env.REACT_APP_API_URL + 'token/refresh/'
    ) {
      window.location.href = '/auth/login/';
      return Promise.reject(error);
    }

    // if we get invalid token, we will generate a new token from refresh token
    if (
      error.response.data.code === 'token_not_valid' &&
      error.response.status === 401 &&
      error.response.statusText === 'Unauthorized'
    ) {
      const refreshToken = JSON.parse(
        localStorage.getItem('refresh_token') as string,
      );

      if (refreshToken) {
        const tokenParts = JSON.parse(atob(refreshToken.split('.')[1]));

        // exp date in token is expressed in seconds, while now() returns milliseconds:
        const now = Math.ceil(Date.now() / 1000);

        if (tokenParts.exp > now) {
          return axiosInstance
            .post('/api/auth/login/refresh/', { refresh: refreshToken })
            .then((response) => {
              localStorage.setItem(
                'access_token',
                JSON.stringify(response.data.access),
              );
              localStorage.setItem(
                'refresh_token',
                JSON.stringify(response.data.refresh),
              );
              axiosInstance.defaults.headers.common.Authorization =
                'JWT ' + response.data.access;
              originalRequest.headers.Authorization =
                'JWT ' + response.data.access;

              return axiosInstance(originalRequest);
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          //if the token is expired, we will redirect the user to the login page

          window.location.href = '/auth/login/';
        }
      } else {
        // if the refresh token is not available

        window.location.href = '/auth/login/';
      }
    }

    // specific error handling done elsewhere
    return Promise.reject(error);
  },
);
